import styled, { css } from "styled-components";
import { Timeline as TimelineAntd } from "antd";

export const Container = styled.div`
  box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;

  @media (min-width: 768px) {
    width: 20rem;
  }
`;

export const Content = styled.div`
  ${({ theme }) => css`
    z-index: 1;

    img {
      width: 100%;
      height: 12rem;
      object-fit: cover;
      border-radius: 8px;
    }

    @media (min-width: 768px) {
      img {
        height: 13rem;
      }
    }
  `}
`;
export const Description = styled.div`
  ${({ theme }) => css`
    padding: 1rem;
    background-color: ${theme.colors.ultraLightGray};
    border-radius: 8px;
    margin-top: -1rem;
    position: relative;
    z-index: 2;

    p {
      margin: 0;
      font-size: 0.875rem;
      color: ${theme.colors.black};
    }

    @media (min-width: 768px) {
      p {
        font-size: 1rem;
      }
    }
  `}
`;

export const Timeline = styled(TimelineAntd)`
  ${({ theme }) => css`
    margin-top: 0.5rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    li {
      &:last-child {
        display: none;
      }
    }
  `}
`;

export const History = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    padding: 1rem;
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.black};
    font-size: 0.75rem;
    text-transform: uppercase;
    font-weight: bold;
  `}
`;

export const ItemHistory = styled.div`
  ${({ theme }) => css`
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        color: ${theme.colors.black};
        margin: 0;
        font-size: 0.875rem;
      }

      span {
        font-size: 0.75rem;
        color: ${theme.colors.black};
        opacity: 0.5;
      }
    }

    > span {
      display: block;
      margin-top: 1rem;
      font-size: 0.75rem;
      color: ${theme.colors.black};
      opacity: 0.5;
    }
  `}
`;
